import styled from 'styled-components'

const CellContent = styled.div`
  height: 100%;

  &:empty {
    display: none;
  }
`

export default CellContent
